import React, {memo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Col, Row, UiBox, UiButton, UiImage, UiQuestionnaireLayout, UiSimpleGrid, UiText} from '~/components/elements';
import {ScrollToBottomButton} from '~/components/shared/ScrollToBottomButton';
import {HOT_FLASHES_TREATMENT_KEYS, YES_OPTION} from '~/constants/medical-questionnaires';
import {useInput, useNotification} from '~/hooks';
import {setNextQuestionnaire, setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {Relation} from '~/redux/questionnaires/types';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {spacing} from '~/utils/theme/spacing';

const Questionnaire9Screen = () => {
  const dispatch: AppDispatch = useDispatch();

  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = questionnaires?.find(i => i.key === HOT_FLASHES_TREATMENT_KEYS.UP_TO_DATE_BREAST_SCREENINGS);

  const currentAnswer = useSelector(
    (state: RootState) =>
      state.questionnaires?.collectData[HOT_FLASHES_TREATMENT_KEYS.UP_TO_DATE_BREAST_SCREENINGS]?.data,
  );

  const {inputs, setInputs} = useInput({
    selectedOption: currentAnswer?.selectedOption || '',
    lastMammogram: currentAnswer?.lastMammogram || '',
  });

  const onClickSubmit = async () => {
    dispatch(
      setQuestionnaireAnswer({
        key: HOT_FLASHES_TREATMENT_KEYS.UP_TO_DATE_BREAST_SCREENINGS,
        index: questionnaire?.index || '',
        data: inputs,
      }),
    );
    dispatch(setNextQuestionnaire({value: HOT_FLASHES_TREATMENT_KEYS.OTHER_CONDITION_OR_MEDICAL_HISTORY}));
  };

  const renderScreening = () => {
    return (
      <UiBox w="100%">
        <UiText my={spacing.medium} variant="mdqTitle">
          {questionnaire?.questions?.sub}
        </UiText>
        <UiSimpleGrid columns={{base: 1, lg: 2}} spacing={5} mt={spacing.small}>
          {questionnaire?.screeningOptions?.map(i => {
            return (
              <UiButton
                key={`${i.label}-${i.value}`}
                title={i.label}
                variant={inputs.lastMammogram === i?.value ? 'solid' : 'toggle'}
                onClick={() => setInputs({lastMammogram: i.value})}
              />
            );
          })}
        </UiSimpleGrid>
      </UiBox>
    );
  };

  return (
    <UiQuestionnaireLayout
      actions={questionnaire?.actions}
      disableNext={!inputs.selectedOption || !inputs.lastMammogram}
      handleOnNext={onClickSubmit}
      checkoutStep={questionnaire?.checkoutStep}
    >
      <Col alignItems="center" textAlign="center">
        <UiText my={10} variant="mdqTitle">
          {questionnaire?.questions?.default}
        </UiText>
        <Row justifyContent="center" w="100%">
          {questionnaire?.options?.map(value => (
            <UiButton
              onClick={() => setInputs({selectedOption: value?.value})}
              key={`${value.label}-${value.value}`}
              title={value?.label}
              variant={inputs?.selectedOption === value.value ? 'solid' : 'toggle'}
              w="100%"
              mx={1}
            />
          ))}
        </Row>
        {renderScreening()}
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire9Screen;
